/**
 * 品牌官网模块路由
 * 路径前缀: /desktopCenter/brandWebsite/
 */
import type { RouteRecordRaw } from "vue-router";

export const brandWebsiteRoutes: RouteRecordRaw[] = [
	{
		path: "/desktopCenter/brandWebsite/pageDecoration",
		name: "BrandPageDecoration",
		meta: {
			title: "页面装修",
			keepAlive: false,
		},
		redirect: "/desktopCenter/brandWebsite/pageDecoration/pageList",
		children: [
			{
				path: "/desktopCenter/brandWebsite/pageDecoration/pageList",
				name: "BrandWebsitePageList",
				meta: {
					title: "页面列表",
					keepAlive: false,
				},
				component: () =>
					import("@main/views/Apps/BrandWebsite/PageDecoration/PageList/PageList.vue"),
			},
			{
				path: "/desktopCenter/brandWebsite/pageDecoration/personalCenter",
				name: "BrandWebsiteBrandPersonalCenter",
				meta: {
					title: "个人中心",
					keepAlive: false,
				},
				component: () =>
					import("@main/views/Apps/BrandWebsite/PageDecoration/PersonalCenter/PersonalCenter.vue"),
			},
		],
	},
	{
		path: "/desktopCenter/brandWebsite/navigationConfig",
		name: "BrandWebsiteBrandNavigationConfig",
		meta: {
			title: "导航配置",
			keepAlive: false,
		},
		component: () => import("@main/views/Apps/BrandWebsite/NavigationConfig/NavigationConfig.vue"),
	},
	{
		path: "/desktopCenter/brandWebsite/newsInfo",
		name: "NewsInfo",
		meta: {
			title: "新闻资讯",
			keepAlive: false,
		},
		redirect: "/desktopCenter/brandWebsite/newsInfo/articleManage",
		children: [
			{
				path: "/desktopCenter/brandWebsite/newsInfo/articleManage",
				name: "ArticleManage",
				meta: {
					title: "文章管理",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/article/article",
				},
				component: () =>
					import("@main/views/Apps/BrandWebsite/NewsInfo/ArticleManage/ArticleManage.vue"),
			},
			{
				path: "/desktopCenter/brandWebsite/newsInfo/category",
				name: "NewsCategory",
				meta: {
					title: "分类",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/article/article_cat",
				},
				component: () =>
					import(
						"@main/views/Apps/BrandWebsite/NewsInfo/BrandWebsiteCategory/BrandWebsiteCategory.vue"
					),
			},
		],
	},
	{
		path: "/desktopCenter/brandWebsite/faq",
		name: "Faq",
		meta: {
			title: "常见问题",
			keepAlive: false,
			iframeUrl: "cos.php/wdsxh/faq",
		},
		component: () => import("@main/views/Apps/BrandWebsite/BrandWebsiteFaq/BrandWebsiteFaq.vue"),
	},
	{
		path: "/desktopCenter/brandWebsite/domainBinding",
		name: "DomainBinding",
		meta: {
			title: "域名绑定",
			keepAlive: false,
		},
		component: () => import("@main/views/Apps/BrandWebsite/DomainBinding/DomainBinding.vue"),
	},
];
